import { render, staticRenderFns } from "./cpBtn.vue?vue&type=template&id=1dae5b70&scoped=true&"
import script from "./cpBtn.vue?vue&type=script&lang=js&"
export * from "./cpBtn.vue?vue&type=script&lang=js&"
import style0 from "./cpBtn.vue?vue&type=style&index=0&id=1dae5b70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dae5b70",
  null
  
)

export default component.exports